export default function loadExternalScript(sourceURL) {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${sourceURL}"]`)) {
      resolve();

      return;
    }

    const scriptElement = document.createElement('script');

    scriptElement.type = 'text/javascript';
    scriptElement.async = true;
    scriptElement.defer = true;
    scriptElement.src = sourceURL;

    scriptElement.addEventListener('load', resolve);
    scriptElement.addEventListener('error', reject);
    scriptElement.addEventListener('abort', reject);

    document.head.appendChild(scriptElement);
  });
}
